// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"55ce8d5c","668":"e0f9fd0a"}[chunkId] + ".chunk.js";
};